<template>
  <div id="SeasonSuites">
    <HeroSlider :sliderImages="sliderImages" />
    <section id="suites">
      <Suites />
    </section>
  </div>
</template>

<script>
import HeroSlider from "@/components/HeroSlider";
import Suites from "@/components/SeasonSuites/Suites";
import { seasonSuitesImages } from "@/data/seasonSuitesSliderData.js";

export default {
  name: "SeasonSuites",
  components: {
    HeroSlider,
    Suites,
  },
  data() {
    return {
      sliderImages: seasonSuitesImages,
    };
  },
};
</script>

<style lang="scss" scoped>
#SeasonSuites {
  margin: 0;
}
</style>
